module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--sp-9a8861983c62c5b8406893bb5cfe9b52.webp";